module.exports = __webpack_public_path__ + "static/19-3d94e8a73dde1c2a9d93220dc8ad3fa9.jpg";